<template>
  <div
  class="flex flex-wrap rounded border-gray-400 border-l-4  shadow-2l cursor-pointer  mx-4 md:mx-auto max-w-md md:max-w-xl bg-white  transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-105"
  :class="{ 'border-indigo-500': selected }"
  >
    <!--horizantil margin is just for display-->
    <div class="flex items-start px-6 py-6">
      <i class="bx mr-6 text-indigo-500 text-2xl" :class="icon"></i>
      <div class>
        <div class="flex items-center justify-between">
          <h2 class="text-lg font-semibold text-gray-900  mb-0 ">{{ name }}</h2>
        </div>
      </div>
    </div>
    <div class="w-full text-gray-700">
      <transition name="fade" >
        <slot name="form"></slot>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    icon: String,
    selected: Boolean
  }
}
</script>

<style>
</style>
